// extracted by mini-css-extract-plugin
export default {"root":"Fjx_2o763uwgW4mPMKxv","review-work":"tCvJzq9Qh_Y9gzY3gP_W"};